import { render, staticRenderFns } from "./articleDetails.vue?vue&type=template&id=8a2e1754&scoped=true"
import script from "./articleDetails.vue?vue&type=script&lang=js"
export * from "./articleDetails.vue?vue&type=script&lang=js"
import style0 from "./articleDetails.vue?vue&type=style&index=0&id=8a2e1754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2e1754",
  null
  
)

export default component.exports